import AssetBasedService from 'assets-based-service';
import { SERVICE_NAME } from '../constants';
import Logger from './Logger';

/**
 * By default Logger is disabled. For enabling need to set in localStorage debug=<moduleName>
 * Or set env variable NODE_DEBUG=<moduleName>
 * In this case <moduleName> - 'AssetBasedService'
 * @type {Logger}
 */
export const logger = new Logger(`${SERVICE_NAME}:AssetBasedService`);
const service = new AssetBasedService(SERVICE_NAME, logger);

export default service;
